import { Certificate } from './certificate';
import { MembershipStatus } from '../../data-space/services/federator-onboarding.service';

/** Read-only wallet row. The local numeric id is never sent to certificate APIs. */
export class MembershipCertificate extends Certificate {
  constructor(readonly membership: MembershipStatus, readonly credential: any, vc: any = null) {
    const issuer = typeof vc?.issuer === 'string' ? vc.issuer : vc?.issuer?.id;
    super(-1, credential ? 'Construct-X Mitgliedsausweis' : 'Construct-X Mitgliedschaft',
      null, issuer || 'Construct-X Federator', null, 'verified_user',
      vc?.validFrom || vc?.issuanceDate || null, null, vc?.validUntil || vc?.expirationDate || null,
      false, [], credential ? 'AUSWEIS_GESPEICHERT' : 'AUSWEIS_AUSSTEHEND', null, credential);
  }
}
